var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPoundCard(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2 5C2 3.89543 2.89543 3 4 3H20C21.1046 3 22 3.89543 22 5V7.25H2V5Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2 8.75V15C2 16.1046 2.89543 17 4 17H10.5764C10.5261 16.674 10.5 16.3401 10.5 16C10.5 12.4101 13.4101 9.5 17 9.5C19.0104 9.5 20.8077 10.4127 22 11.8464V8.75H2Z",
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M17 21C19.7614 21 22 18.7614 22 16C22 13.2386 19.7614 11 17 11C14.2386 11 12 13.2386 12 16C12 18.7614 14.2386 21 17 21ZM17.75 12.75C18.7151 12.75 19.4529 13.4589 19.6759 14.3099C19.7808 14.7106 19.5411 15.1205 19.1404 15.2255C18.7397 15.3305 18.3298 15.0908 18.2248 14.6901C18.145 14.3855 17.9226 14.25 17.75 14.25C17.5462 14.25 17.25 14.4598 17.25 14.8889V15.5278H18.5C18.9142 15.5278 19.25 15.8636 19.25 16.2778C19.25 16.692 18.9142 17.0278 18.5 17.0278H17.2426C17.2234 17.2776 17.1678 17.5212 17.0802 17.75H19C19.4142 17.75 19.75 18.0858 19.75 18.5C19.75 18.9142 19.4142 19.25 19 19.25H15C14.5858 19.25 14.25 18.9142 14.25 18.5C14.25 18.0858 14.5858 17.75 15 17.75C15.3018 17.75 15.6552 17.4896 15.7339 17.0278H15C14.5858 17.0278 14.25 16.692 14.25 16.2778C14.25 15.8636 14.5858 15.5278 15 15.5278H15.75V14.8889C15.75 13.7839 16.5731 12.75 17.75 12.75Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPoundCard);
export default __webpack_public_path__ + "static/media/pound-card.ddabbc2556b88a26506ccd1d39ffbb67.svg";
export { ForwardRef as ReactComponent };